import React, { useEffect, useState } from 'react';

function systemTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
}

function storedTheme() {
    try {
        const value = localStorage.getItem('theme');
        return value === 'light' || value === 'dark' ? value : null;
    } catch (e) {
        return null;
    }
}

/* One control, two outcomes. With no stored choice the site follows the OS
   (and keeps following it if the OS changes). The first click pins a theme,
   the second flips it; the label says what a click will do, not what you are
   looking at. */
export default function ThemeToggle() {
    const [preference, setPreference] = useState(storedTheme);
    const [system, setSystem] = useState(systemTheme);

    const resolved = preference || system;

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', resolved);
    }, [resolved]);

    useEffect(() => {
        if (preference) {
            return undefined;
        }
        const query = window.matchMedia('(prefers-color-scheme: dark)');
        const onChange = () => setSystem(query.matches ? 'dark' : 'light');
        query.addEventListener('change', onChange);
        return () => query.removeEventListener('change', onChange);
    }, [preference]);

    const next = resolved === 'dark' ? 'light' : 'dark';

    const choose = () => {
        setPreference(next);
        try {
            localStorage.setItem('theme', next);
        } catch (e) {
            /* private mode: the choice simply will not persist */
        }
    };

    return (
        <button
            type="button"
            className="theme-toggle"
            onClick={choose}
            aria-label={`Switch to ${next} theme`}
            title={`Switch to ${next} theme`}
        >
            {next}
        </button>
    );
}
